/* eslint-disable max-lines */
/* eslint-disable complexity */
import {
  BookWidgetAirportUpdateInfo,
  BookWidgetDateUpdateInfo,
  BookWidgetFieldUpdateEvent,
  BookWidgetFieldUpdateTypes,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetState } from '../../models/states/book-widget-state.interfaces';
import {
  updateBookWidgetConnectionAirportFn,
  updateBookWidgetDestinationAirportFn,
  updateBookWidgetOriginAirportFn
} from './book-widget-airports-field-update.adapter';
import { updateBookWidgetBestFareOptionsFn } from './book-widget-best-fare-options-update.adapter';
import { updateBookWidgetDatesFn } from './book-widget-dates-field-update.adapter';
import { updateBookWidgetPassengerFn } from './book-widget-passenger-field-update.adapter';
import { updateBookWidgetTripTypeFn } from './book-widget-trip-type-field-update.adapter';

export const bookWidgetFieldsUpdate = (
  state: BookWidgetState,
  bookWidgetFieldUpdateEvent: BookWidgetFieldUpdateEvent
): BookWidgetState => {
  switch (bookWidgetFieldUpdateEvent.type) {
    case BookWidgetFieldUpdateTypes.originAirport: {
      const updatedAirportsField = updateBookWidgetOriginAirportFn(
        state,
        bookWidgetFieldUpdateEvent.data as BookWidgetAirportUpdateInfo
      );
      return {
        ...state,
        fields: {
          ...state.fields,
          airportsField: {
            ...state.fields.airportsField,
            airports: updatedAirportsField
          }
        }
      };
    }
    case BookWidgetFieldUpdateTypes.destinationAirport: {
      const updatedAirportsField = updateBookWidgetDestinationAirportFn(
        state,
        bookWidgetFieldUpdateEvent.data as BookWidgetAirportUpdateInfo
      );
      return {
        ...state,
        fields: {
          ...state.fields,
          airportsField: {
            ...state.fields.airportsField,
            airports: updatedAirportsField
          }
        }
      };
    }
    case BookWidgetFieldUpdateTypes.connectionAirport: {
      const updatedAirportsField = updateBookWidgetConnectionAirportFn(
        state,
        bookWidgetFieldUpdateEvent.data as BookWidgetAirportUpdateInfo
      );
      return {
        ...state,
        fields: {
          ...state.fields,
          airportsField: {
            ...state.fields.airportsField,
            airports: updatedAirportsField
          }
        }
      };
    }
    case BookWidgetFieldUpdateTypes.tripType: {
      const updatedTripTypeField = updateBookWidgetTripTypeFn(
        state,
        bookWidgetFieldUpdateEvent.data as TripTypeOptions
      );
      return {
        ...state,
        fields: {
          ...state.fields,
          tripTypesField: updatedTripTypeField
        }
      };
    }
    case BookWidgetFieldUpdateTypes.datesChange: {
      const updatedDatesField = updateBookWidgetDatesFn(
        state,
        bookWidgetFieldUpdateEvent.data as BookWidgetDateUpdateInfo
      );
      return {
        ...state,
        fields: {
          ...state.fields,
          datesField: {
            dates: updatedDatesField
          }
        }
      };
    }
    case BookWidgetFieldUpdateTypes.passenger: {
      const updatedPassengerField = updateBookWidgetPassengerFn(
        state,
        bookWidgetFieldUpdateEvent.data as string
      );
      return {
        ...state,
        fields: {
          ...state.fields,
          passengerField: updatedPassengerField
        }
      };
    }
    case BookWidgetFieldUpdateTypes.shopMiles: {
      return {
        ...state,
        fields: {
          ...state.fields,
          shopMilesField: {
            ...state.fields.shopMilesField,
            checked: bookWidgetFieldUpdateEvent.data as boolean
          }
        }
      };
    }
    case BookWidgetFieldUpdateTypes.refundableFare: {
      return {
        ...state,
        fields: {
          ...state.fields,
          refundableFareField: {
            ...state.fields.refundableFareField,
            checked: bookWidgetFieldUpdateEvent.data as boolean
          }
        }
      };
    }
    case BookWidgetFieldUpdateTypes.flexDates: {
      return {
        ...state,
        fields: {
          ...state.fields,
          flexDatesField: {
            ...state.fields.flexDatesField,
            checked: bookWidgetFieldUpdateEvent.data as boolean
          }
        }
      };
    }
    case BookWidgetFieldUpdateTypes.basicFares: {
      return {
        ...state,
        fields: {
          ...state.fields,
          basicFaresField: {
            ...state.fields.basicFaresField,
            checked: bookWidgetFieldUpdateEvent.data as boolean
          }
        }
      };
    }
    case BookWidgetFieldUpdateTypes.flexAirport: {
      return {
        ...state,
        fields: {
          ...state.fields,
          flexAirportsField: {
            ...state.fields.flexAirportsField,
            checked: bookWidgetFieldUpdateEvent.data as boolean
          }
        }
      };
    }
    case BookWidgetFieldUpdateTypes.bestFareOptions: {
      const updatedBestFareOptionsField = updateBookWidgetBestFareOptionsFn(
        state,
        bookWidgetFieldUpdateEvent.data as string
      );
      return {
        ...state,
        fields: {
          ...state.fields,
          bestFareOptionsField: updatedBestFareOptionsField
        }
      };
    }
    case BookWidgetFieldUpdateTypes.meetingEventCode: {
      return {
        ...state,
        fields: {
          ...state.fields,
          meetingEventCodeField: {
            ...state.fields.meetingEventCodeField,
            meetingEventCodeValue: bookWidgetFieldUpdateEvent.data as string
          }
        }
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};
